export const CONTENTFUL_COLOR = {
  ORANGE: 'Orange',
  LIGHT_GREEN: 'Light Green',
  DARK_GREEN: 'Dark Green',
  MUSTARD: 'Mustard',
}
